export const getLicense = (data) => {
    const cookie = document.cookie.split("; ")
    .find(row => row.startsWith(data));
    if (!cookie) return null;
    return JSON.parse(decodeURIComponent(cookie.split("=")[1]));
}